import { useCallback } from 'react';

export const useHandleInputChange = (setItems) => {
    return useCallback((index, field, value) => {
        setItems((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? { ...item, [field]: value } : item // Update only the specific item
            )
        );
    }, [setItems]);
};

export const useHandleFileChange = (setItems) => {
    const handleInputChange = useHandleInputChange(setItems);
    return useCallback((e, index, field = 'backgroundImage') => {
        const file = e.target.files[0];
        if (file) {
            handleInputChange(index, field, file);
        }
    }, [handleInputChange]);
};

export const useHandleRemoveImage = (setItems) => {
    const handleInputChange = useHandleInputChange(setItems);
    return useCallback((index, field = 'backgroundImage') => {
        handleInputChange(index, field, null);
    }, [handleInputChange]);
};